import React from "react";
import FilterRadioButtons from "../../forms/filter-radio-buttons";
import {
  orderStatusoptions,
  paymentStatusoptions,
} from "../../helper-components/data";

const InvoiceFilter = ({ setFilterData, filterData, setCurrentPage }) => {
  const handleOrderStatusChange = (e) => {
    setFilterData({
      ...filterData,
      order_status: e.target.value,
    });
    setCurrentPage(1);
  };

  const handlePaymentStatusChange = (e) => {
    setFilterData({
      ...filterData,
      payment_status: e.target.value,
    });
    setCurrentPage(1);
  };
  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "17rem",
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0 12px 32px -8px var(--popover-shadow-color), 0 2px 6px -2px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-3 px-2  bg-[var(--popover-bg-color)]  rounded-xl z-10 flex flex-col"
    >
      <span className="px-3 pt-1.5 pb-2.5 text-sm fw_600 text-[var(--popover-heading-fg-color)]">
        Filter by
      </span>
      <hr className="border-0 border-t border-[var(--popover-border-color)] -mx-2" />
      <div className="">
        <FilterRadioButtons
          valueclass="flex gap-5 items-center"
          name="order_sataus"
          label={"Order Status"}
          options={orderStatusoptions}
          handleChange={handleOrderStatusChange}
          value={filterData?.order_status}
        />
        <FilterRadioButtons
          valueclass="flex gap-5 items-center"
          name="payment_sataus"
          label={"Payment Status"}
          options={paymentStatusoptions}
          handleChange={handlePaymentStatusChange}
          value={filterData?.payment_status}
        />
      </div>
    </div>
  );
};

export default InvoiceFilter;
